import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SectionHeading from "./SectionHeading";
import { insights } from "../content/insights";
import { useT, useLocalePath } from "../i18n/useT";

export default function InsightsPreview() {
  const t = useT();
  const localePath = useLocalePath();
  const items = insights.slice(0, 3);
  return (
    <section
      id="insights"
      className="py-24 sm:py-28 border-t border-ink-800/60 bg-ink-900/30"
    >
      <div className="container-page">
        <SectionHeading
          eyebrow={t.insightsPreview.eyebrow}
          title={t.insightsPreview.title}
          lede={t.insightsPreview.lede}
        />
        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((p) => (
            <Link
              key={p.slug}
              to={localePath(`/insights/${p.slug}`)}
              className="group flex flex-col rounded-xl border border-ink-800 bg-ink-900/50 p-6 transition hover:border-ink-700 hover:bg-ink-900/80"
            >
              <span className="font-mono text-xs uppercase tracking-wider text-accent-500">
                {p.category}
              </span>
              <h3 className="mt-3 text-lg font-semibold text-ink-50 leading-snug">
                {p.title}
              </h3>
              <p className="mt-3 text-sm text-ink-300 leading-relaxed flex-1">
                {p.excerpt}
              </p>
              <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-accent-400 group-hover:text-accent-500">
                {t.insightsPreview.read}
                <ArrowRight className="size-4" />
              </span>
            </Link>
          ))}
        </div>
        <div className="mt-10">
          <Link to={localePath("/insights")} className="btn-ghost">
            {t.insightsPreview.viewAll}
            <ArrowRight className="size-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
